module.exports = __webpack_public_path__ + "static/media/comprar-imovel-joinville.a68c32b4.webp";